exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (max-width: 440px){.menu-food-dialog .el-dialog{width:auto !important}.el-message-box{width:auto !important}}\n", ""]);

// exports
